import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const BusinessAdministrationHeader = ({ componentData }) => {
  // Use componentData from CMS if available, otherwise use defaults
  const title = componentData?.title || "Business";
  const subtitle = componentData?.subtitle || "Administration";
  const content = componentData?.content || "Lead. Manage. Succeed.";
  const backgroundImage = componentData?.mediaUrl || "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2072&q=80";

  return (
    <CourseHeader
      title={title}
      highlight={subtitle}
      subtitle={content}
      backgroundImage={backgroundImage}
      cta={{ label: "Start Application", targetId: "application-form" }}
    />
  );
};

export default BusinessAdministrationHeader;
